import React from "react";
import cx from "classnames";
import { useTranslation, useI18next } from "gatsby-plugin-react-i18next";
import {
  DestinationToolTipBody,
  BaliPropertyToolTipBody,
} from "components/Design/MenuToolTipBody/MenuTooltipBody";
import DESTINATION from "dictionaries/destinations";
import { embedLanguageInUrl } from "utils/embedLanguageInUrl";
import { DestinationCard } from "components/Design/Card";
import ConditionalLink from "components/ConditionalLink";
import { CardHotelList, CardHotel } from "components/Design/Card";
import HOTEL_PROPERTY_BALI_URL from "dictionaries/hotelBali";
import {
  AYANA_RESORT_AND_SPA,
  RIMBA_JIMBARAN_BALI,
  VILLAS_AYANA_RESORT_BALI,
  AYANA_SEGARA_BALI,
} from "store/constants/hotel";

import "./TopBar.less";
import Tooltip from "./Design/Tooltip/Tooltip";
import Icon from "./CommonIcon/Icon";

export const NumberBadge = ({ number }) => (
  <span className="absolute right-0 transform translate-x-12 rounded-full w-14 h-14 bg-blue-ayana">
    <span className="block mx-auto mt-1 font-bold text-center font-mulish text-9 text-text-white tracking-8 leading-11">
      {number}
    </span>
  </span>
);

export const TopBarItem = ({
  children,
  suffixIcon,
  prefixIcon,
  to,
  onClick,
  isHighlighted,
  ...props
}) => {
  const content = (
    <div className="flex items-center cursor-pointer tracking-16">
      {prefixIcon}
      <p
        className={cx("uppercase border-box", {
          "ml-4": Boolean(prefixIcon),
          "mr-4": Boolean(suffixIcon),
        })}>
        {children}
      </p>
      {suffixIcon}
    </div>
  );

  return (
    <div className="relative flex flex-col justify-center" onClick={onClick}>
      {to ? (
        <ConditionalLink
          link={to}
          className={cx({
            "topbar-item-active": isHighlighted,
          })}
          activeClassName="topbar-item-active"
          external={Boolean(props.newTab)}
          {...props}>
          {content}
        </ConditionalLink>
      ) : (
        content
      )}
    </div>
  );
};

const TopBar = ({
  destinationCards,
  children,
  navigationHotel,
  hotelPropertyBali,
}) => {
  const { t } = useTranslation();
  const { language } = useI18next();

  return (
    <div className="flex py-10 font-semibold text-white bg-black px-30 font-mulish text-10-10">
      <div className="topbar-dropdown">
        <div className="topbar-dropdown-item">
          <Tooltip
            trigger={<TopBarItem>{t("Select Destination")}</TopBarItem>}
            tooltipPosition="left"
            openOnHover>
            <DestinationToolTipBody>
              {destinationCards.map((destination) => {
                const destinationLink = DESTINATION[destination.title];
                const link = destinationLink.startsWith("https://")
                  ? embedLanguageInUrl(destinationLink, language)
                  : destinationLink;
                return (
                  <DestinationCard
                    key={destination.id}
                    name={destination.name}
                    title={t(destination.title)}
                    to={link}
                    image={destination?.mobile}
                    fullWidth={true}
                  />
                );
              })}
            </DestinationToolTipBody>
          </Tooltip>
        </div>
        {(navigationHotel === AYANA_RESORT_AND_SPA ||
          navigationHotel === RIMBA_JIMBARAN_BALI ||
          navigationHotel === VILLAS_AYANA_RESORT_BALI ||
          navigationHotel === AYANA_SEGARA_BALI) &&
          hotelPropertyBali && (
            <div className="topbar-dropdown-item">
              <Tooltip
                trigger={<TopBarItem>{t("Select Hotels")}</TopBarItem>}
                tooltipPosition="left"
                openOnHover>
                <BaliPropertyToolTipBody>
                  <CardHotelList>
                    {hotelPropertyBali?.map((hotel) => {
                      return (
                        <CardHotel
                          logo={hotel.logo}
                          title={hotel.title}
                          to={HOTEL_PROPERTY_BALI_URL[hotel.name]}
                        />
                      );
                    })}
                  </CardHotelList>
                </BaliPropertyToolTipBody>
              </Tooltip>
            </div>
          )}
      </div>
      <div className="flex ml-auto space-x-20 -pr-20">{children}</div>
    </div>
  );
};

export default TopBar;
